import { createSlice } from "@reduxjs/toolkit";
import {
  addParent,
  getAvailableLanguages,
  getLanguageSettings,
  getSettings,
  getSystemAnnouncement,
  getPaymentStatus
} from "./actions";

const initialState = {
  settings: null,
  loading: false,
  systemAnnouncement: null,
  systemAnnouncementLoading: false,
  paymentStatus: null,
  paymentStatusLoading: false,
  error: "",
  parentWallet: null,
  language: {}, // stores current selected language translations
  languageList: [], // stores all available languages
};

export const settingsSlice = createSlice({
  name: "settings",
  initialState,
  extraReducers: (builder) => {
    builder
      // 🔹 getSettings
      .addCase(getSettings.pending, (state) => {
        state.loading = true;
        state.error = "";
      })
      .addCase(getSettings.fulfilled, (state, action) => {
        state.loading = false;
        state.settings = action.payload;
      })
      .addCase(getSettings.rejected, (state) => {
        state.loading = false;
      })

      // 🔹 addParent
      .addCase(addParent.pending, (state) => {
        state.loading = true;
        state.error = "";
      })
      .addCase(addParent.fulfilled, (state, action) => {
        state.loading = false;
        state.parentWallet = action.payload;
      })
      .addCase(addParent.rejected, (state) => {
        state.loading = false;
      })

      // 🔹 getLanguageSettings
      .addCase(getLanguageSettings.pending, (state) => {
        state.loading = true;
        state.error = "";
      })
      .addCase(getLanguageSettings.fulfilled, (state, action) => {
        state.loading = false;
        state.language = { ...action.payload };
      })
      .addCase(getLanguageSettings.rejected, (state, action) => {
        state.loading = false;
        state.error = action.payload || "Failed to fetch language settings";
      })

      // 🔹 getAvailableLanguages
      .addCase(getAvailableLanguages.pending, (state) => {
        state.loading = true;
      })
      .addCase(getAvailableLanguages.fulfilled, (state, action) => {
        state.loading = false;
        state.languageList = action.payload;
      })
      .addCase(getAvailableLanguages.rejected, (state, action) => {
        state.loading = false;
        state.error = action.payload || "Failed to fetch language list";
      })

      // 🔹 getSystemAnnouncement
      .addCase(getSystemAnnouncement.pending, (state) => {
        state.systemAnnouncementLoading = true;
        state.error = "";
      })
      .addCase(getSystemAnnouncement.fulfilled, (state, action) => {
        state.systemAnnouncementLoading = false;
        state.systemAnnouncement = action.payload;
      })
      .addCase(getSystemAnnouncement.rejected, (state) => {
        state.systemAnnouncementLoading = false;
      })

      .addCase(getPaymentStatus.pending, (state) => {
        state.paymentStatusLoading = true;
        state.error = "";
      })
      .addCase(getPaymentStatus.fulfilled, (state, action) => {
        state.paymentStatusLoading = false;
        state.paymentStatus = action.payload;
      })
      .addCase(getPaymentStatus.rejected, (state) => {
        state.paymentStatusLoading = false;
      });
  },
});

export default settingsSlice.reducer;
